import clsx from 'clsx'
import React, { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { ISummaryContent } from '../summary/Summary'
import { breakpoints, useMediaQuery } from '../../../../../lib/hooks'

const INDENTATION_SIZE = 20
const MOBILE_INDENTATION_SIZE = 10

const Article = ({
  summaryContent,
  children,
  isSubArticle = false,
  centerTitle = false,
}: {
  summaryContent: ISummaryContent
  children: ReactNode
  isSubArticle?: boolean
  centerTitle?: boolean
}) => {
  const isMobile = useMediaQuery(breakpoints.newMobile)
  const indentationNumber = summaryContent.article?.split('.').length
    ? summaryContent.article?.split('.').length - 1
    : 0
  return (
    <div className={s.articleSection} id={summaryContent.hrefId}>
      <h2
        style={{
          marginLeft: centerTitle
            ? '0'
            : `${(isMobile ? INDENTATION_SIZE : MOBILE_INDENTATION_SIZE) * indentationNumber}px`,
          textAlign: centerTitle ? 'center' : 'left',
        }}
        className={clsx({ [s.italic]: summaryContent.isItalic })}
      >
        {summaryContent.article && !isSubArticle ? (
          <FormattedMessage id='ui.Article.article' defaultMessage='Article' />
        ) : (
          summaryContent.annex && (
            <FormattedMessage id='ui.Article.annex' defaultMessage='Annexe' />
          )
        )}{' '}
        {summaryContent.article ? summaryContent.article : summaryContent.annex}
        {summaryContent.article ? '.' : ' -'} {summaryContent.title}
      </h2>
      {children}
    </div>
  )
}
export default Article
